import type {AnalyticsApi} from './type';

export const consoleApi: AnalyticsApi = {
    initialize() {
        return Promise.resolve();
    },
    logEvent(name: string, params: Record<string, unknown>) {
        console.log('[analytics] event:', name, params);
        return Promise.resolve();
    },
    setScreenName(screenName: string, params: Record<string, unknown>) {
        console.log('[analytics] screen name:', screenName, params);
        return Promise.resolve();
    },
    setUserProperty(name: string, value: string) {
        console.log('[analytics] user property:', name, value);
        return Promise.resolve();
    },
};
